export default {
  time: 'hh:mm A',
  timeHour: 'hh A',
  date: 'MMM D',
  dateTime: 'MMM D, hh:mm A',
  dateTimeHour: 'MMM D, hh A',
  dateYear: 'MMM D, YYYY',
  dateYearTime: 'MMMM D, YYYY, hh:mm A',
};
